import React from 'react';
import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';

const catalogueUrl = "https://heyzine.com/flip-book/d8789c509d.html";

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-orange-500 to-orange-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Prêt à organiser votre événement ?
        </h2>
        <p className="text-lg text-orange-100 mb-8">
          Obtenez un devis gratuit en quelques minutes. Notre équipe vous accompagne de A à Z.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/devis"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-orange-600 font-semibold rounded-full hover:bg-gray-100 transition-colors"
          >
            Demander un Devis Gratuit
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
